<template>
  <el-container class="home-container">
    <el-header class="home-header">
      <img src="@/assets/images/logo.png" alt="">
      <span>出货物料单管理系统</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{nickName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="unlogin">退出</span>
          </el-dropdown-item>
           <el-dropdown-item>
            <span @click="restPassword">修改密码</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <el-main>
        <el-card shadow="never" class="box-card">
          <div class="add-client-wrap">
            <div class="title">物料单记录</div>
            <el-button style="margin-left:10px;" icon="el-icon-circle-plus-outline" @click="addShipmentDialog" plain size="small" type="primary">新增物料单</el-button>
          </div>
          <div class="filter-list-wrap">
            <span>筛选条件：</span>
            <el-input
              style="width:200px;"
              placeholder="输入出货备注"
              v-model="remark"
              clearable>
            </el-input>
          </div>
          <div class="table-wrap">
            <el-table
              :data="listData"
              stripe>
              <el-table-column
                width="190px"
                prop="moNumber"
                label="物料单号">
              </el-table-column>
              <el-table-column
                label="物料类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.moType==1">订单</span>
                  <span v-if="scope.row.moType==2">样品</span>
                  <span v-if="scope.row.moType==3">外借</span>
                  <span v-if="scope.row.moType==4">变更系统</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="systemName"
                width="250"
                label="子系统">
              </el-table-column>
              <el-table-column
                label="系统类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.systemType==1">太阳能</span>
                  <span v-if="scope.row.systemType==2">市电</span>
                </template>
              </el-table-column>
              <el-table-column
                label="状态">
                <template slot-scope="scope">
                  <el-tag type="warning" v-if="scope.row.moStatus==0">待出货</el-tag>
                  <el-tag type="success" v-if="scope.row.moStatus==1">已出货</el-tag>
                  <el-tag type="info" v-if="scope.row.moStatus==2">已撤销</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="是否完结">
                <template slot-scope="scope">
                  <template v-if="scope.row.moStatus==1">
                    <el-button style="color:orange" v-if="scope.row.isOver==0" @click="getRemark(scope.row.moNumber)" type="text" size="small">未完结</el-button>
                    <el-tag type="success" v-if="scope.row.isOver==1">已完结</el-tag>
                  </template>
                  <template v-else>--</template>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdAt"
                label="新增时间">
                <template slot-scope="scope">
                  {{scope.row.createdAt | time}}
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="220">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text" size="small">详情</el-button>
                  <el-button v-if="scope.row.moStatus!=2" @click="updateDetail(scope.row)" type="text" size="small">更新快递</el-button>
                  <el-button v-else type="text" size="small" disabled>更新快递</el-button>
                  <el-button v-if="scope.row.moStatus==0" @click="editDetail(scope.row)" type="text" size="small">修改信息</el-button>
                  <el-button v-else type="text" size="small" @click="updateSystemBtn(scope.row)" :disabled="scope.row.moStatus!=1">变更系统</el-button>
                  <el-button v-if="scope.row.moStatus==0" @click="cancelMoInfos(scope.row.id)" type="text" size="small">撤销</el-button>
                  <el-button v-else type="text" size="small" disabled>撤销</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table-page-wrap">
            <el-pagination
              @current-change="currentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </el-card>
        <!-- 新增物料单 -->
        <el-dialog
          :title="dialogTitle"
          :close-on-click-modal="false"
          :visible.sync="shipmentDialog"
          :before-close="closeDialog"
          width="400px">
          <template v-if="dialogTitle !== '更新快递信息' && shipmentData.moType != 4">
            <div class="dialog-item">物料单类型：</div>
            <el-select
              v-model="shipmentData.moType"
              placeholder="请选择物料单类型">
              <el-option label="订单" :value="1"></el-option>
              <el-option label="样品" :value="2"></el-option>
              <el-option label="外借" :value="3"></el-option>
            </el-select>
          </template>
          <template v-if="dialogTitle !== '更新快递信息'">
            <div class="dialog-item">子系统信息：</div>
            <el-cascader
              v-model="systemSelected"
              clearable
              filterable
              placeholder="请选择子系统"
              expand-trigger="hover"
              :options="systemListSelect"
              @change="systemListhandleChange">
            </el-cascader>
          </template>
          <template v-if="dialogTitle !== '更新快递信息' && shipmentData.moType != 4">
            <div class="dialog-item">物料信息：</div>
            <el-input
              placeholder="请输入物料信息"
              v-model="shipmentData.materialInfo"
              clearable>
            </el-input>
          </template>
          <template v-if="dialogTitle !== '更新快递信息' && shipmentData.moType != 4">
            <div class="dialog-item">计费周期（月）：</div>
            <el-input
              placeholder="请输入计费周期月份数，无计费周期则填0"
              v-model="shipmentData.useCycle"
              clearable>
            </el-input>
          </template>
          <template v-if="dialogTitle !== '更新快递信息' && shipmentData.moType != 4">
            <div class="dialog-item">收件信息：</div>
            <el-input
              placeholder="请输入收件信息"
              v-model="shipmentData.receiptInfo"
              clearable>
            </el-input>
          </template>
          <template v-if="dialogTitle === '新增物料单' || dialogTitle === '更新快递信息'">
            <div class="dialog-item">快递信息：</div>
            <el-input
              placeholder="请输入快递信息"
              v-model="shipmentData.expressInfo"
              clearable>
            </el-input>
          </template>
          <template v-if="dialogTitle !== '更新快递信息'">
            <div class="dialog-item">备注：</div>
            <el-input
              placeholder="请输入备注内容"
              v-model="shipmentData.remark"
              clearable>
            </el-input>
          </template>
          <template v-if="dialogTitle !== '更新快递信息'">
            <div class="dialog-item">出货截至时间：</div>
            <el-date-picker
              :clearable="false"
              :editable="false"
              v-model="shipmentData.latestShipmentTime"
              align="right"
              type="date"
              placeholder="选择日期"
              value-format="timestamp"
              :picker-options="pickerOptions1">
            </el-date-picker>
          </template>
          <div v-if="dialogTitle === '新增物料单'" class="sub-system-wrap">
            <el-button style="margin-top: 8px;width:100%" type="success" @click="submitUpload">新增物料单</el-button>
          </div>
          <div v-if="dialogTitle === '变更系统'" class="sub-system-wrap">
            <el-button style="margin-top: 8px;width:100%" type="success" @click="submitUpload">新增变更记录</el-button>
          </div>
          <div v-if="dialogTitle === '修改物料单'" class="sub-system-wrap">
            <el-button style="margin-top: 8px;width:100%" type="success" @click="editUpload">修改物料单</el-button>
          </div>
          <div v-if="dialogTitle === '更新快递信息'" class="sub-system-wrap">
            <el-button style="margin-top: 8px;width:100%" type="success" @click="updateUpload">更新快递信息</el-button>
          </div>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
          title="修改密码"
          :visible.sync="resetPasswordDialog"
          :close-on-click-modal="false"
          width="30%">
          <el-form label-width="80px">
            <el-form-item label="旧密码">
              <el-input type="password" v-model.trim="password.old"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input type="password" v-model.trim="password.new"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input type="password" v-model.trim="password.confirm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetPasswordBtn" type="success">确认修改</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog
          title="出货物料单详情"
          :visible.sync="dialogVisible"
          width="500px">
          <detail :moDdetail="moDdetail"></detail>
        </el-dialog>
      </el-main>
    </el-container>
    <el-footer class="home-footer">©Coyperight2016-2018华泉出货管理系统</el-footer>
  </el-container>
</template>

<script>
import '@/assets/stylus/home.styl';
import detail from '../monitor/detail';
import http from 'http';

export default {
  components: {
    detail
  },
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      fileLength: 0,
      password: {
        old: '',
        new: '',
        confirm: ''
      },
      moDdetail: {},
      dialogVisible: false,
      shipmentData: {
        moType: '', // 物料单类型；1-订单；2-样品；3-外借
        systemId: 0, // 子系统ID
        systemType: 0, // 子系统类型；1-太阳能，2-市电，3-智能开关,4-井盖；5-液位；6-新井盖
        materialInfo: '', // 物料信息
        useCycle: 0, // 计费周期(月)
        receiptInfo: '', // 收件信息
        expressInfo: '', // 快递信息
        remark: '', // 备注
        latestShipmentTime: Date.now() // 出货截止时间
      },
      systemSelected: [],
      itemId: '',
      remark: '',
      dialogTitle: '',
      resetPasswordDialog: false,
      reshipmentDialog: false,
      shipmentDialog: false,
      filterTimestamp: null,
      filterSystemId: '',
      systemList: [],
      systemListSelect: [],
      systemType: 1,
      productModelOptions: [],
      systemId: '',
      nickName: '',
      username: '',
      tableData: [],
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000;
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },
  computed: {
    listData () {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      return this.tableData.map(item => {
        this.systemList.forEach(subItem => {
          if (item.systemId === subItem.id) item['systemName'] = subItem.name;
          if (item.systemId === 0) item['systemName'] = '回收SN操作';
        });
        return item;
      }).filter(item => item.remark.indexOf(this.remark) !== -1).slice(start, end);
    },
    total () {
      return this.tableData.filter(item => item.remark.indexOf(this.remark) !== -1).length;
    }
  },
  methods: {
    openDetail (detail) {
      this.dialogVisible = true;
      this.moDdetail = detail;
    },
    // 获取出货未完成的备注
    async getRemark (id) {
      let { data } = await http.get(`/v1/mo-infos/shipment-remark?moNumber=${id}`);
      this.$alert(`${data.remark}`, '未完结原因：', {
        confirmButtonText: '确定'
      });
    },
    systemListhandleChange (val) {
      this.systemType = val[0];
      this.shipmentData.systemType = val[0];
      if (val[1] === 36) {
        this.shipmentData.systemId = 1;
      } else {
        this.shipmentData.systemId = val[1];
      }
    },
    // 更新快递信息弹窗
    updateDetail (detail) {
      let params = Object.assign({}, detail);
      this.itemId = params.id;
      this.shipmentData = params;
      this.systemSelected = [params.systemType, params.systemId];
      this.dialogTitle = '更新快递信息';
      this.shipmentDialog = true;
    },
    updateSystemBtn (detail) {
      let params = Object.assign({}, detail);
      this.shipmentData = params;
      this.shipmentData.moType = 4;
      this.shipmentData.remark = '';
      this.dialogTitle = '变更系统';
      this.shipmentDialog = true;
    },
    // 修改物料单详情
    editDetail (detail) {
      let params = Object.assign({}, detail);
      this.itemId = params.id;
      this.shipmentData = params;
      this.systemSelected = [params.systemType, params.systemId];
      this.dialogTitle = '修改物料单';
      this.shipmentDialog = true;
    },
    resetFormData () {
      this.systemSelected = [];
      this.shipmentData = {
        moType: '', // 物料单类型；1-订单；2-样品；3-外借
        systemId: 0, // 子系统ID
        systemType: 0, // 子系统类型；1-太阳能，2-市电，3-智能开关,4-井盖；5-液位；6-新井盖
        materialInfo: '', // 物料信息
        receiptInfo: '', // 收件信息
        expressInfo: '', // 快递信息
        remark: '', // 备注
        latestShipmentTime: Date.now() // 出货截止时间86400000
      };
    },
    closeDialog (done) {
      this.resetFormData();
      done();
    },
    addShipmentDialog () {
      this.shipmentDialog = true;
      this.dialogTitle = '新增物料单';
    },
    // 撤销物料单
    cancelMoInfos (id) {
      this.$confirm('此操作将撤销该物料单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let { data } = await http.put(`/v1/mo-infos/cancel/${id}`);
        if (data.code === 200) {
          this.updateList();
          this.$message({
            type: 'success',
            message: '撤销成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消撤销'
        });
      });
    },
    // 新增物料单
    async submitUpload () {
      if (this.shipmentData.systemId !== '') {
        if (isNaN(this.shipmentData.useCycle)) {
          this.$notify({
            title: '警告',
            message: '计费周期不合法',
            type: 'warning'
          });
          return false;
        }
        this.shipmentData.latestShipmentTime = Number(this.shipmentData.latestShipmentTime) + 86399999;
        let { data } = await http.post(`/v1/mo-infos`, this.shipmentData);
        if (data.code === 200) {
          this.$notify({
            title: '提示',
            message: '新增成功',
            type: 'success'
          });
          this.updateList();
          this.shipmentDialog = false;
          this.resetFormData();
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请选择子系统',
          type: 'warning'
        });
      }
    },
    // 更新快递信息
    async updateUpload () {
      let { data } = await http.put(`/v1/mo-infos/update-express-info`, {
        id: this.itemId,
        expressInfo: this.shipmentData.expressInfo
      });
      if (data.code === 200) {
        this.updateList();
        this.shipmentDialog = false;
        this.$message({
          type: 'success',
          message: '更新成功!'
        });
      }
    },
    // 修改物料单
    async editUpload () {
      if (isNaN(this.shipmentData.useCycle)) {
        this.$notify({
          title: '警告',
          message: '计费周期不合法',
          type: 'warning'
        });
        return false;
      }
      this.shipmentData.latestShipmentTime = Number(this.shipmentData.latestShipmentTime);
      let params = Object.assign({}, this.shipmentData);
      delete params.expressInfo;
      let { data } = await http.put(`/v1/mo-infos/${this.itemId}`, params);
      if (data.code === 200) {
        this.updateList();
        this.shipmentDialog = false;
        this.$message({
          type: 'success',
          message: '更新成功!'
        });
      }
    },
    currentChange (val) {
      // 发送请求
      this.currentPage = val;
    },
    // 获取物料单列表
    async updateList () {
      let result = {};
      if (this.filterSystemId === undefined) this.filterSystemId = '';
      result = await http.get(`/v1/mo-infos/mine`);
      this.tableData = result.data;
    },
    // 获取子系统
    async getSystemList () {
      let { data } = await http.get('/v1/sub-systems');
      this.systemList = data;
      let solorList = this.systemList.filter(item => item.systemType === 1).map(item => {
        return {
          value: item.id,
          label: item.name
        };
      });
      let smartGridList = this.systemList.filter(item => item.systemType === 2).filter(item => item.id !== 38).map(item => {
        return {
          value: item.id,
          label: item.name
        };
      });
      this.systemListSelect = [
        {
          value: 1,
          label: '太阳能',
          children: solorList
        },
        {
          value: 2,
          label: '市电',
          children: smartGridList
        }
      ];
    },
    // 退出登录
    unlogin () {
      this.$store.commit('updateToken', '');
      sessionStorage.clear();
      this.$router.push({name: 'login'});
    },
    async resetPasswordBtn () {
      if (this.password.new.length < 6 || this.password.new.length > 16) {
        this.$message({
          message: '密码长度为6-16个字符',
          type: 'warning'
        });
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.$message({
          message: '两次输入的新密码不同',
          type: 'warning'
        });
        return false;
      }
      let { data } = await http.post(`/v1/me/password`, {
        oldPassword: this.password.old,
        newPassword: this.password.new
      });
      if (data.success === true) {
        this.$message({
          message: '密码修改成功',
          type: 'success'
        });
        this.resetPasswordDialog = false;
        this.$router.push({name: 'login'});
      }
    },
    restPassword () {
      this.resetPasswordDialog = true;
    }
  },
  async created () {
    // 获取用户列表
    this.updateList(1, 10);
    this.getSystemList();
    try {
      this.nickName = JSON.parse(sessionStorage.getItem('userInfo')).nickname || '华泉智能';
      this.username = JSON.parse(sessionStorage.getItem('userInfo')).username || '';
    } catch (e) {
    }
  }
};
</script>

<style scoped>
.el-dialog .el-cascader {
  margin-bottom: 7px;
  width: 100%;
}
.dialog-item {
  color: #999;
  line-height: 32px;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale/index.vue